import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=47618f48&scoped=true"
import script from "./Classification.vue?vue&type=script&lang=js"
export * from "./Classification.vue?vue&type=script&lang=js"
import style0 from "./Classification.vue?vue&type=style&index=0&id=47618f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47618f48",
  null
  
)

export default component.exports